import { render, staticRenderFns } from "./PrivacySectionComponent.vue?vue&type=template&id=d94ae28e"
import script from "./PrivacySectionComponent.vue?vue&type=script&lang=js"
export * from "./PrivacySectionComponent.vue?vue&type=script&lang=js"
import style0 from "./PrivacySectionComponent.vue?vue&type=style&index=0&id=d94ae28e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports